import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-secondary-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h2 className="text-2xl font-bold mb-4">InternshipHub</h2>
            <p className="text-secondary-400 mb-4">
              Empowering students to find meaningful internships and kickstart their careers.
              Connect with top companies and gain real-world experience.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" className="text-secondary-400 hover:text-primary-400 transition-colors">
                <FaFacebook size={24} />
              </a>
              <a href="https://twitter.com" className="text-secondary-400 hover:text-primary-400 transition-colors">
                <FaTwitter size={24} />
              </a>
              <a href="https://instagram.com" className="text-secondary-400 hover:text-primary-400 transition-colors">
                <FaInstagram size={24} />
              </a>
              <a href="https://linkedin.com" className="text-secondary-400 hover:text-primary-400 transition-colors">
                <FaLinkedin size={24} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-secondary-400 hover:text-primary-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/internships" className="text-secondary-400 hover:text-primary-400 transition-colors">
                  Internships
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-secondary-400 hover:text-primary-400 transition-colors">
                  Register
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-secondary-400 hover:text-primary-400 transition-colors">
                  Login
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2 text-secondary-400">
              <li>Email: info@internshiphub.in</li>
              <li>Phone: +91 98765 43210</li>
              <li>Address: Mumbai, India</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-8 pt-8 text-center text-secondary-400">
          <p>&copy; {new Date().getFullYear()} InternshipHub. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
